"use client";

import Link from "next/link";
import cls from "./Button.module.css";

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  target?: boolean;
  invert?: boolean;
  className?: string;
  ariaLabel?: string;
}

export const Button = ({
  children,
  onClick,
  href,
  target = false,
  invert = false,
  className = '',
  ariaLabel = '',
}: ButtonProps) => {
  return (
    href ?
    <Link href={href} onClick={onClick ? onClick : () => {}} className={`${cls.button} ${invert ? cls.invert : ''} ${className}`} rel={target ? "noopener noreferrer" : undefined} target={target ? "_blank" : undefined} aria-label={ariaLabel}>
      {children}
    </Link>
    :
    <button onClick={onClick ? onClick : () => {}} className={`${cls.button} ${invert ? cls.invert : ''} ${className}`} aria-label={ariaLabel}>
      {children}
    </button>
  );
};